import type { AdminPermission } from "./permissions";
import { ROLE_PERMISSIONS, type AdminRole } from "./roles";

export function hasPermission(
  role: AdminRole | undefined | null,
  permission: AdminPermission,
): boolean {
  if (!role) return false;
  return ROLE_PERMISSIONS[role].includes(permission);
}

export function hasAnyPermission(
  role: AdminRole | undefined | null,
  permissions: readonly AdminPermission[],
): boolean {
  return permissions.some((p) => hasPermission(role, p));
}
